export default function makeQuery(filters, corpId, isPilot, isOpen) {
  const query = {};
  filters.forEach((option) => {
    const { key, active, activeOption } = option;
    if (active) {
      if (key === 'vendor') {
        query.vendor = activeOption.value;
      }
      if (key === 'status') {
        query.statuses = [activeOption.value];
      }
      if (key === 'orderTypes') {
        query.orderTypes = [activeOption.value];
      }
      if (key === 'sortBy') {
        query.sortBy = activeOption.value;
      }
      if (key === 'techs') {
        query.techId = activeOption.value;
      }
      if (key === 'orderDate') {
        query.fromOrderDate = activeOption.value.start;
        query.toOrderDate = activeOption.value.end;
      }
    }

    if (corpId) {
      query.corpId = corpId;
    }
    if (isPilot) {
      query.isPilot = true;
    }
    if (isOpen) {
      query.isOpen = true;
    }
    query.onlyRecentOpen = true;
    query.withoutFreemium = true;
  });
  return query;
}
